import React from 'react';
import PropTypes from 'prop-types';

export default function withI18n(Component) {
  Component.contextTypes = Component.contextTypes || {};
  Component.contextTypes.i18n = PropTypes.object.isRequired;
  return Component;
}



// WEBPACK FOOTER //
// ./spa/Components/Context/withI18n.jsx